export default "__VITE_ASSET__32a6b675__"